import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import {
  willCpuLimitBeExceeded,
  willMemoryLimitBeExceeded,
} from '../../../../utils';

type UseShowTopologyLimitsWarningAddVmFromDemoReturn = {
  onAddClicked: VoidFunction;
};

export type UseShowTopologyLimitsWarningAddVmFromDemoProps = {
  topologyLimitsWarningAccepted?: boolean;
  resetTopologyLimits: VoidFunction;
  addVm: VoidFunction;
  vm?: VirtualMachine;
  topologyLimits?: TopologyLimits;
  setShowTopologyLimitWarningForEntity: ActionCreatorWithOptionalPayload<
    | TopologyLimitsDisplayLabels
    | Array<TopologyLimitsDisplayLabels>
    | undefined,
    string
  >;
};

export function useShowTopologyLimitsWarningAddVmFromDemo({
  topologyLimitsWarningAccepted,
  resetTopologyLimits,
  addVm,
  vm,
  topologyLimits,
  setShowTopologyLimitWarningForEntity,
}: UseShowTopologyLimitsWarningAddVmFromDemoProps): UseShowTopologyLimitsWarningAddVmFromDemoReturn {
  useEffect(() => {
    if (topologyLimitsWarningAccepted) {
      resetTopologyLimits();
      addVm();
    }
  }, [addVm, resetTopologyLimits, topologyLimitsWarningAccepted]);
  const onAddClicked = () => {
    if (!vm || !topologyLimits) {
      addVm();
      resetTopologyLimits();
      return;
    }
    const memoryLimitExceeded = willMemoryLimitBeExceeded(
      vm,
      topologyLimits.memoryMb,
    );
    const cpuLimitExceeded = willCpuLimitBeExceeded(
      vm,
      topologyLimits.cpuCores,
    );

    switch (memoryLimitExceeded) {
      case true:
        cpuLimitExceeded
          ? setShowTopologyLimitWarningForEntity(['Memory (GB)', 'vCPUs'])
          : setShowTopologyLimitWarningForEntity('Memory (GB)');
        break;
      case false:
        cpuLimitExceeded
          ? setShowTopologyLimitWarningForEntity('vCPUs')
          : addVm();
        break;
      default:
        addVm();
        resetTopologyLimits();
        break;
    }
  };

  return { onAddClicked };
}
